import i18n from "../language/i18n";

export const retrieveReportTypeOptionList = () => {
  return [
    {
      value: "USER",
      text: i18n.t("USER"),
    },
    {
      value: "USER_PROFILE",
      text: i18n.t("USER_PROFILE"),
    },
    {
      value: "BRANCH",
      text: i18n.t("BRANCH"),
    },
    {
      value: "GRADE",
      text: i18n.t("GRADE"),
    },
    {
      value: "SEASON",
      text: i18n.t("SEASON"),
    },
    {
      value: "INSTITUTION",
      text: i18n.t("INSTITUTION"),
    },
    {
      value: "CAMPUS",
      text: i18n.t("CAMPUS"),
    },
    {
      value: "REGION",
      text: i18n.t("REGION"),
    },
    {
      value: "BRAND",
      text: i18n.t("BRAND"),
    },
  ];
};

const recursivelyIncludeCategoryActivityAnswerDTO = (
  parentCategoryActivityAnswerDTO: any,
  categoryActivityAnswerDTO: any
) => {
  const { subCategoryActivityAnswerDTOList } = parentCategoryActivityAnswerDTO;
  if (subCategoryActivityAnswerDTOList.length === 0) return;
  const foundCategoryActivityAnswerDTOById =
    subCategoryActivityAnswerDTOList.find(
      (answerDTO: any) =>
        answerDTO.categoryDTO.id === categoryActivityAnswerDTO.categoryDTO.id
    );
  if (foundCategoryActivityAnswerDTOById) {
    foundCategoryActivityAnswerDTOById.activityScoreDTOSet.push(
      ...categoryActivityAnswerDTO.activityScoreDTOSet
    );
  } else {
    if (
      parentCategoryActivityAnswerDTO.categoryDTO?.code ===
      categoryActivityAnswerDTO.categoryDTO.parentCode
    ) {
      subCategoryActivityAnswerDTOList.push(categoryActivityAnswerDTO);
    } else {
      for (const answerDTO of subCategoryActivityAnswerDTOList) {
        recursivelyIncludeCategoryActivityAnswerDTO(
          answerDTO,
          categoryActivityAnswerDTO
        );
      }
    }
  }
};

const recursivelyIncludeCategoryActivityAnswerDTOList = (
  parentCategoryActivityAnswerDTO: any,
  categoryActivityAnswerDTOList: any[]
) => {
  for (const newAnswerDTO of categoryActivityAnswerDTOList) {
    recursivelyIncludeCategoryActivityAnswerDTO(
      {
        subCategoryActivityAnswerDTOList:
          parentCategoryActivityAnswerDTO.currentCategoryActivityAnswerDTOList,
      },
      newAnswerDTO
    );
    const { subCategoryActivityAnswerDTOList } = newAnswerDTO;
    // if (subCategoryActivityAnswerDTOList.length === 0) return;
    recursivelyIncludeCategoryActivityAnswerDTOList(
      parentCategoryActivityAnswerDTO,
      subCategoryActivityAnswerDTOList
    );
  }
};
export const constructCombinedBranchAssignmentReportMap = (
  filteredSelectedLearnerBranchAssignmentReportDTOList: any[]
) => {
  const combinedBranchAssignmentReportMap: any = {};
  const copyFilteredSelectedLearnerBranchAssignmentReportDTOList =
    JSON.parse(
      JSON.stringify(
        filteredSelectedLearnerBranchAssignmentReportDTOList
      )
    );
  for (const learnerBranchAssignmentReportDetailDTO of copyFilteredSelectedLearnerBranchAssignmentReportDTOList) {
    const {
      branchAssignmentDTO,
      categoryActivityAnswerDTOList,
    } = learnerBranchAssignmentReportDetailDTO;
    const { coterieType } = branchAssignmentDTO;
    const currentCategoryActivityAnswerDTOList =
      combinedBranchAssignmentReportMap[coterieType];
    if (currentCategoryActivityAnswerDTOList) {
      recursivelyIncludeCategoryActivityAnswerDTOList(
        { currentCategoryActivityAnswerDTOList },
        categoryActivityAnswerDTOList
      );
    } else {
      combinedBranchAssignmentReportMap[coterieType] =
        categoryActivityAnswerDTOList;
    }
  }
  return combinedBranchAssignmentReportMap;
};

// Build a per-coterieType map of flat SkillActivityScoreDTO entries from the
// learner's BranchAssignmentReportDetail list. Activity.skillIdSet is the
// source of truth — entries with the same skillId are merged across assignments.
export const constructCombinedBranchAssignmentSkillReportMap = (
  filteredSelectedLearnerBranchAssignmentReportDTOList: any[]
) => {
  const combinedSkillReportMap: Record<string, any[]> = {};
  for (const reportDetail of filteredSelectedLearnerBranchAssignmentReportDTOList) {
    const branchAssignmentDTO = reportDetail.branchAssignmentDTO;
    const skillList = reportDetail.skillActivityScoreDTOList || [];
    if (!branchAssignmentDTO || skillList.length === 0) continue;
    const coterieType = branchAssignmentDTO.coterieType;
    if (!combinedSkillReportMap[coterieType]) combinedSkillReportMap[coterieType] = [];
    const bucket = combinedSkillReportMap[coterieType];
    for (const entry of skillList) {
      const skillId = entry.skillId;
      if (!skillId) continue;
      const scores = entry.activityScoreDTOSet || entry.activityScoreList || [];
      const scoresArray = Array.isArray(scores) ? scores : Array.from(scores);
      const existing = bucket.find((b: any) => b.skillId === skillId);
      if (existing) {
        const existingScores = existing.activityScoreDTOSet || [];
        existing.activityScoreDTOSet = [
          ...(Array.isArray(existingScores) ? existingScores : Array.from(existingScores)),
          ...scoresArray,
        ];
      } else {
        bucket.push({ skillId, activityScoreDTOSet: scoresArray });
      }
    }
  }
  return combinedSkillReportMap;
};

export const constructOutcomeActivityScoreList = (data: any) => {
  const outcomeActivityScoreList: any[] = [];

  const traverseCategories = (categoryData: any, parentPath = "") => {
    const currentPath = parentPath
      ? `${parentPath} > ${categoryData.categoryDTO.name}`
      : categoryData.categoryDTO.name;

    if (categoryData.subCategoryActivityAnswerDTOList.length === 0) {
      const scores = categoryData.activityScoreList ||
        (categoryData.activityScoreDTOSet ? Array.from(categoryData.activityScoreDTOSet) : []);
      const outcomeActivityScore = {
        code: categoryData.categoryDTO.code,
        name: categoryData.categoryDTO.name,
        count: scores.length,
        score: 0,
        timeSpent: 0,
      };

      scores.forEach((activity: any) => {
        outcomeActivityScore.score += activity.score;
        outcomeActivityScore.timeSpent += activity.timeSpent;
      });

      outcomeActivityScoreList.push(outcomeActivityScore);
    } else {
      categoryData.subCategoryActivityAnswerDTOList.forEach(
        (subCategory: any) => {
          traverseCategories(subCategory, currentPath);
        }
      );
    }
  };

  data.forEach((rootCategory: any) => {
    traverseCategories(rootCategory);
  });

  return outcomeActivityScoreList;
};

export const constructCombinedOutcomeActivityScoreMapFromCombinedReport = (
  combinedCorporateAssessmentAssignmentReportMap: any
) => {
  const combinedOutcomeActivityScoreMap: any = {};

  Object.keys(combinedCorporateAssessmentAssignmentReportMap).forEach(
    (coterieType) => {
      const categoryActivityAnswerDTOList =
        combinedCorporateAssessmentAssignmentReportMap[coterieType];
      const outcomeActivityScoreListFromCoterieType =
        constructOutcomeActivityScoreList(categoryActivityAnswerDTOList);
      combinedOutcomeActivityScoreMap[coterieType] =
        outcomeActivityScoreListFromCoterieType;
    }
  );

  return combinedOutcomeActivityScoreMap;
};
